import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import TablePagination from "./TablePagination";
import { getMobileUsers } from "../Apis/UserAPIs";
import { toast } from "react-toastify";
import { formatDate } from "../helper/DateHelper";

const UserListLayer = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const params = {
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm || undefined,
            };
            const result = await getMobileUsers(params);
            if (result.status) {
                setUsers(result.response.data || []);
                setTotalItems(result.response.total || 0);
            }
        } catch (error) {
            console.error("Error fetching mobile users:", error);
            toast.error("Failed to fetch mobile users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [currentPage, rowsPerPage, searchTerm]);

    const totalPages = Math.ceil(totalItems / rowsPerPage);

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
            <div
                className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between"
                style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
            >
                <h6 className="text-white mb-0 fw-bold">Mobile App Users</h6>
                <div className="position-relative" style={{ width: "300px" }}>
                    <input
                        type="text"
                        className="form-control form-control-sm radius-8 ps-32"
                        placeholder="Search by Name, Email or Mobile..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(0);
                        }}
                        style={{
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            border: "1px solid rgba(255,255,255,0.2)",
                            color: "black",
                            fontWeight: "500"
                        }}
                    />
                    <Icon
                        icon="solar:magnifer-linear"
                        className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75"
                    />
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive border radius-8 bg-white overflow-x-auto shadow-sm">
                    <table className="table bordered-table sm-table mb-0" style={{ minWidth: '1000px' }}>
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" className="fw-bold text-white py-12 px-16" style={{ width: '70px' }}>S.No</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '200px' }}>Name</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '250px' }}>Email</th>
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '150px' }}>Mobile Number</th>
                                {/* <th scope="col" className="fw-bold text-white py-12" style={{ width: '150px' }}>User Type</th> */}
                                <th scope="col" className="fw-bold text-white py-12" style={{ width: '200px' }}>Registration Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-24">
                                        <div className="spinner-border text-danger" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : users.length > 0 ? (
                                users.map((user, index) => {
                                    const userTypeVal = user.usertype || user.userType || "visitor";
                                    return (
                                        <tr key={user._id || index}>
                                            <td><div>{currentPage * rowsPerPage + index + 1}</div></td>
                                            <td><div>{user.fullName}</div></td>
                                            <td><div>{user.email || "-"}</div></td>
                                            <td><div>{user.mobileNumber || user.phoneNumber || "-"}</div></td>
                                            {/* <td>
                                                <span
                                                    className={`badge ${
                                                        userTypeVal.toLowerCase() === "exhibitor"
                                                            ? "bg-danger-focus text-danger-main"
                                                            : "bg-info-focus text-info-main"
                                                    } px-12 py-6 radius-4 fw-bold uppercase`}
                                                    style={{ fontSize: "10px", minWidth: "80px" }}
                                                >
                                                    {userTypeVal.toUpperCase()}
                                                </span>
                                            </td> */}
                                            <td><div>{formatDate(user.createdAt)}</div></td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-24 text-secondary-light">
                                        No users found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-24">
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(val) => {
                            setRowsPerPage(val);
                            setCurrentPage(0);
                        }}
                        totalRecords={totalItems}
                    />
                </div>
            </div>
        </div>
    );
};

export default UserListLayer;
